/**
 * ****************************************************************************
 * @description     :   sidebar menu on mobile
 * @created at      :   2022/07/13
 * @created by      :   
 * @package         :   dailyreportsystem
 * @copyright       :   Copyright (c)
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import SimpleBar from "simplebar-react";
import PropTypes from "prop-types";

/**
 * import custom hook
 */
import useOnClickOutside from "../hooks/use-onclick-outside";

/**
 * import for redux
 */
import Actions from "../redux/app/actions";

/**
 * Create component sidebar menu, will dispaly in mobile when user click button toggle menu
 * -----------------------------------------
 * @author : create
 * @param  : {Object} props - Properties of this component
 * @access : public
 */
const SidebarMobile = (props) => {
    const ref = useRef();
    const dispatch = useDispatch();

    // create state of this component
    // to detect the openning menu
    const [_state, setNewState] = useState({
        openningChildMenu: 0,
        openningChildMenu2: 0
    });

    const { openningMenuMobile, sidebarMenus } = props;

    // Close this sidebar when click outside this sidebar
    useOnClickOutside(ref, (event) => {
        if(event.target.className.includes !== undefined){
            if (!event.target.className.includes("toggle_mobile_sidebar")) {
                dispatch(Actions.CloseMenuMobile());
            }
        }
    });

    /**
     * Open or close the child menu level 1
     * -----------------------------------------
     * @author : create
     * @param  : {Object} menu - The clicked menu
     * @access : private
     */
    const OpenChildMenu = (menu) => {
        // close child menu if re-click this menu
        let openningChildMenu = 0;
        if (_state.openningChildMenu !== menu.id) {
            // if click other menu, if that menu have child menu then open that child menu
            if (menu.childMenu && menu.childMenu.length > 0) {
                openningChildMenu = menu.id;
            }
            // if click menu not have child menu then close all child menu and close sidebar
            else {
                openningChildMenu = 0;
                dispatch(Actions.CloseMenuMobile());
            }
        }
        // apply to state to rerender view
        setNewState({
            ..._state,
            openningChildMenu
        });
    }

    /**
     * Open or close the child menu level 2
     * -----------------------------------------
     * @author : create
     * @param  : {Object} menu - The child menu leve 1 had clicked
     * @access : private
     */
    const OpenChildMenu2 = (menu) => {
        // close child menu if re-click this menu
        let openningChildMenu2 = 0;
        let {openningChildMenu} = _state;
        if (_state.openningChildMenu2 !== menu.id) {
            // if click other menu, if that menu have child menu then open that child menu
            if (menu.childMenu && menu.childMenu.length > 0) {
                openningChildMenu2 = menu.id;
            }
            // if click menu not have child menu then close all child menu and close sidebar
            else {
                openningChildMenu2 = 0;
                openningChildMenu = 0;
                dispatch(Actions.CloseMenuMobile());
            }
        }
        // apply to state to rerender view
        setNewState({
            ..._state,
            openningChildMenu,
            openningChildMenu2
        });
    }

    /**
     * Close the sidebar
     * -----------------------------------------
     * @author : create
     * @access : private
     */
    const CloseSidebar = () => {
        dispatch(Actions.CloseMenuMobile());
        // apply to state to rerender view
        setNewState({
            ..._state,
            openningChildMenu: 0,
            openningChildMenu2: 0
        });
    }

    return (
        <>
            <div
                className={`nk-sidebar nk-sidebar-mobile ${openningMenuMobile ? "nk-sidebar-active" : ""}`}
                data-content="sidebarMenu"
                ref={ref}
            >
                <SimpleBar className="nk-sidebar-inner">
                    <ul className="nk-menu nk-menu-md">
                        {sidebarMenus.map((menu) => (
                            <li
                                className={`${menu.type === "header" ? "nk-menu-heading" : ""} ${
                                    menu.type === "menu" ? "nk-menu-item" : ""
                                } ${menu.childMenu && menu.childMenu.length > 0 ? "has-sub" : ""} ${
                                    menu.id === _state.openningChildMenu ? "active" : ""
                                }`}
                                key={menu.id}
                            >
                                {menu.type === "header" ? (
                                    <h6 className="overline-title text-primary-alt">
                                        {menu.title}
                                    </h6>
                                ) : (
                                    <>
                                        <a
                                            href={menu.href}
                                            className={`nk-menu-link ${
                                                menu.childMenu && menu.childMenu.length > 0 ? "nk-menu-toggle" : ""
                                            }`}
                                            onClick={OpenChildMenu.bind(this, menu)}
                                        >
                                            <span className="nk-menu-icon">
                                                <em className={`icon ni ${menu.icon}`} />
                                            </span>
                                            <span className="nk-menu-text">{menu.title}</span>
                                        </a>
                                        {menu.childMenu && menu.childMenu.length && (
                                            <ul className="nk-menu-sub">
                                                {menu.childMenu.map((childMenu1) => (
                                                    <li 
                                                        className={`nk-menu-item ${
                                                            childMenu1.id === _state.openningChildMenu2
                                                            && menu.id === _state.openningChildMenu ? "active" : ""
                                                        }`}
                                                        key={childMenu1.id}
                                                    >
                                                        <a
                                                            href={childMenu1.href}
                                                            className={`nk-menu-link ${
                                                                childMenu1.childMenu && childMenu1.childMenu.length > 0
                                                                    ? "nk-menu-toggle"
                                                                    : ""
                                                            }`}
                                                            onClick={OpenChildMenu2.bind(this, childMenu1)}
                                                        >
                                                            <span className="nk-menu-text">{childMenu1.title}</span>
                                                        </a>
                                                        {childMenu1.childMenu && childMenu1.childMenu.length > 0 && (
                                                            <ul className="nk-menu-sub">
                                                                {childMenu1.childMenu.map((childMenu2) => (
                                                                    <li className="nk-menu-item" key={childMenu2.id}>
                                                                        <a
                                                                            href={childMenu2.href}
                                                                            className="nk-menu-link"
                                                                            onClick={CloseSidebar.bind(this)}
                                                                        >
                                                                            <span className="nk-menu-text">
                                                                                {childMenu2.title}
                                                                            </span>
                                                                        </a>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        )}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </>
                                )}
                            </li>
                        ))}
                    </ul>
                </SimpleBar>
            </div>
            {openningMenuMobile && <div className="nk-sidebar-overlay" data-target="sidebarMenu" />}
        </>
    );
};

SidebarMobile.propTypes = {
    /**
     * the sidebar is openning or is closing
     */
    openningMenuMobile: PropTypes.bool,
    /**
     * list data menus on sidebar
     */
    sidebarMenus: PropTypes.arrayOf(
        PropTypes.shape({
            /**
             * id of menu
             */
            id: PropTypes.number.isRequired,
            /**
             * Type of menu (header or menu item)
             */
            type: PropTypes.string.isRequired,
            /**
             * Name of menu will be display
             */
            title: PropTypes.string.isRequired,
            /**
             * Icon of menu will be display
             */
            icon: PropTypes.string,
            /**
             * Link will be redirect when click menu
             */
            href: PropTypes.string,
            /**
             * List child menu level 1 of this menu
             */
            childMenu: PropTypes.arrayOf(
                PropTypes.shape({
                    /**
                     * id of menu level 1
                     */
                    id: PropTypes.number.isRequired,
                    /**
                     * Name of menu level 1 will be display
                     */
                    title: PropTypes.string.isRequired,
                    /**
                     * Link will be redirect when click menu level 1
                     */
                    href: PropTypes.string,
                    /**
                     * List child menu level 2 of this menu level 1
                     */
                    childMenu: PropTypes.arrayOf(
                        PropTypes.shape({
                            /**
                             * id of menu level 2
                             */
                            id: PropTypes.number.isRequired,
                            /**
                             * Name of menu level 2 will be display
                             */
                            title: PropTypes.string.isRequired,
                            /**
                             * Link will be redirect when click menu level 2
                             */
                            href: PropTypes.string
                        })
                    )
                })
            )
        })
    )
};

SidebarMobile.defaultProps = {
    openningMenuMobile: false,
    sidebarMenus: []
};

export default React.memo(SidebarMobile);
